/**
 * Footer directive
 */
angular.module('acme.common.directive.footer', [])
.directive('footer', [function() {

    return {
      restrict: 'AE',
      replace: true,
      templateUrl: 'common/directives/footer/footer.tpl.html',
      controller: ['$scope', function($scope) {

        $scope.footer = {

        };

      }]
    };

}]);